var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderWithTickSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.69727C0.5 2.17848 1.73122 0.947266 3.25 0.947266H8.67157C9.40092 0.947266 10.1004 1.237 10.6161 1.75272L12.4445 3.58115C12.679 3.81557 12.9969 3.94727 13.3284 3.94727H18.75C20.2688 3.94727 21.5 5.17848 21.5 6.69727V16.1973C21.5 17.716 20.2688 18.9473 18.75 18.9473H3.25C1.73122 18.9473 0.5 17.716 0.5 16.1973V3.69727ZM14.6 8.94939C14.8485 8.61802 14.7814 8.14792 14.45 7.89939C14.1186 7.65086 13.6485 7.71802 13.4 8.04939L10.1562 12.3744L8.51724 10.8134C8.21729 10.5278 7.74256 10.5393 7.4569 10.8393C7.17123 11.1392 7.18281 11.614 7.48276 11.8996L9.73276 14.0425C9.88789 14.1902 10.0988 14.2646 10.3123 14.2468C10.5258 14.229 10.7215 14.1208 10.85 13.9494L14.6 8.94939Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderWithTickSolid);
export default __webpack_public_path__ + "static/media/folder-with-tick-solid.bc61b0d9e4c2e305486130215773088e.svg";
export { ForwardRef as ReactComponent };